export var EventType;
(function (EventType) {
    EventType["SUBSCRIBE"] = "SUBSCRIBE";
    EventType["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    EventType["AKSENROLL"] = "AKSENROLL";
    EventType["AKSERROR"] = "aksError";
    EventType["AKSLEAVE"] = "AKSLEAVE";
    EventType["EnrollStarInAKS"] = "AKSEnroll";
    EventType["Description"] = "description";
    EventType["Deliverability"] = "deliverability";
    EventType["EXPERIANREFERENCE"] = "experianReference";
    EventType["ISCOMPANY"] = "isCompany";
    EventType["NAME"] = "name";
    EventType["EMAIL"] = "email";
    EventType["EMAILVALIDATION"] = "emailValidation";
    EventType["PHONEVALIDATION"] = "phoneValidation";
    EventType["PHONE"] = "phone";
    EventType["ADDRESS"] = "address";
    EventType["ADDRESSPROTECTION"] = "addressProtection";
    EventType["NAMEPROTECTION"] = "nameProtection";
    EventType["CVR"] = "cvr";
    EventType["CPR"] = "cpr";
    EventType["EAN"] = "ean";
    EventType["REGISTRYIDENTIFIER"] = "registryIdentifier";
    EventType["REFERENCEID"] = "referenceId";
    EventType["COMPANYRELATIONS"] = "companyRelations";
    EventType["COMPANYSTATUS"] = "companyStatus";
    EventType["WEBSITE"] = "website";
    EventType["STIFTELSESDATO"] = "stiftelsesdato";
    EventType["ANTALPENHEDER"] = "antalPenheder";
    EventType["VIRKSOMHEDSFORM"] = "virksomhedsform";
    EventType["EMPLOYEES"] = "employees";
    EventType["INDUSTRY"] = "industry";
    EventType["INDUSTRYCODE"] = "industryCode";
    EventType["TEGNINGSREGEL"] = "tegningsregel";
    EventType["REKLAMEBESKYTTET"] = "reklamebeskyttet";
    EventType["RKIALLREGISTRATIONS"] = "rkiAllRegistrations";
    EventType["RKIREGISTRATIONS"] = "rkiRegistrations";
    EventType["RKIDELETION"] = "rkiDeletions";
    EventType["COURT"] = "courtId";
    EventType["GEOCODE"] = "geocode";
    EventType["BIRTHDATE"] = "birthdate";
    EventType["MOVEDABROAD"] = "movedAbroad";
    EventType["AKSCPRSTATUS"] = "aksCPRStatus";
    EventType["AKSKOBSTATUS"] = "aksKOBStatus";
    EventType["AKSKOBSTATUSINITIAL"] = "aksKOBStatusInitial";
    EventType["REALESTATES"] = "realEstates";
    EventType["CARS"] = "cars";
    EventType["COMPANIES"] = "companies";
    EventType["IMAGE"] = "image";
    EventType["ICON"] = "icon";
    EventType["DISSOLVEDSTATUSES"] = "dissolvedStatuses";
    EventType["GUARDIAN"] = "guardian";
    EventType["RKIREPORTED"] = "RKIREPORTED";
    EventType["RKIERROR"] = "RKIERROR";
    EventType["RKIMOVETOOPEN"] = "RKIMOVETOOPEN";
    EventType["RKIPUBLISHED"] = "RKIPUBLISHED";
    EventType["RKIDELETED"] = "RKIDELETED";
    EventType["RKICONCLUDED"] = "RKICONCLUDED";
    EventType["RKISTATUS"] = "RKISTATUS";
    EventType["AddSecondaryEmail"] = "addSecondaryEmail";
    EventType["PatchSecondaryEmail"] = "patchSecondaryEmail";
    EventType["DeleteSecondaryEmail"] = "deleteSecondaryEmail";
    EventType["AddSecondaryPhone"] = "addSecondaryPhone";
    EventType["PatchSecondaryPhone"] = "patchSecondaryPhone";
    EventType["DeleteSecondaryPhone"] = "deleteSecondaryPhone";
})(EventType || (EventType = {}));
export var SourceType;
(function (SourceType) {
    SourceType["AKS"] = "AKS";
    SourceType["EMAILVALIDATION"] = "EMAILVALIDATION";
    SourceType["PHONEVALIDATION"] = "PHONEVALIDATION";
    SourceType["SYSTEM"] = "SYSTEM";
    SourceType["USER"] = "USER";
    SourceType["GRAPHICS"] = "GRAPHICS";
    SourceType["PHONENUMBERLOOKUP"] = "PHONENUMBERLOOKUP";
    SourceType["ETLBBRDAWA"] = "ETLBBRDAWA";
    SourceType["BBR"] = "BBR";
    SourceType["COURT"] = "COURT";
    SourceType["GEOCODE"] = "GEOCODE";
    SourceType["OIS"] = "OIS";
    SourceType["CPR"] = "CPR";
    SourceType["CVR"] = "CVR";
})(SourceType || (SourceType = {}));
//# sourceMappingURL=index.js.map